import React, { Component } from 'react';
import renderHTML from 'react-render-html';

import classes from './LongText.module.scss';

class LongText extends Component {

    constructor(props){

        super(props);

    }

    render(){
        return (
            <div className={classes['long_text']}> 
                {renderHTML(this.props.content.text)}
            </div>
        );
    }
}

export default LongText;